import {CanDeactivateFn} from '@angular/router';
import {UnsavedChanges} from "./unsaved-changes.interface";
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  UnsavedChangesDialogComponent
} from "../../../shared/ui/unsaved-changes-dialog/unsaved-changes-dialog/unsaved-changes-dialog.component";
import {AuditLogsService} from "../../services/audit-logs-service/audit-logs.service";
import {tap} from "rxjs";

/**
 * Prevents instant navigation if the component has unsaved changes.
 * Dialog is opened to confirm the navigation action and discard changes.
 *
 * @param component
 * @param route
 * @param state
 * @param nextState
 */
export const unsavedChangesGuard: CanDeactivateFn<UnsavedChanges> = (
  component,
  route,
  state,
  nextState
) => {
  let dialog = inject(MatDialog);
  let auditLogsService = inject(AuditLogsService);

  const logCancel = () => {
    auditLogsService.logFormCancelled(component.reportType);
  }

  if(component.hasUnsavedChanges()){
    // Open dialog and return the result of its close action (true for "yes", false for "no")
    const dialogRef = dialog.open(UnsavedChangesDialogComponent);
    return dialogRef.afterClosed().pipe(tap(result => {
      if (result) {
        logCancel();
      }
    }));
  }
  else {
    return true;
  }
};
